let moment = require('moment');
let cardValid = require('card-validator');

// Simple regex for validating @ and . in email
export const isEmailValid = (email) => {
  return email && (/.*@.*\..*/).test(email);
}

export const isPasswordValid = (password) => {
  let regex = /^[a-zA-Z0-9\.\-\/)(+=._-]{6,}$/g
  return password && regex.test(password)
}

export const isPasswordMatch = (set, confirm) => {
  return set === confirm
}

// String cannot contain special chars and must be 1 char long. 
export const isInputValid = (str) => {
  str = str.trim(" ")
  let regex = /^[a-zA-Z0-9.\-\/)(+=._-]{1,}$/g
  return regex.test(str)
}

// Checks length and chars within phone number
export const isPhoneNumberValid = (str) => {
  let regex = /^[0-9.\-)(+=._-]{10,15}$/g
  return regex.test(str)
}

// Users must be 18 years or older
export const isDOBValid = (birthday) => {
  let today = moment().add(1, "day").format('L')
  return moment(birthday).add(18, "years").isBefore(today)
}

export const isDateValid = (date) => {
  return moment(date, "MM-DD-YYYY").isValid()
}

// Checks card information for validation
export const isCardValid = (cardInfo) => {
  let { cardNumber, expDate, cvc, zipCode, cardHolderName } = cardInfo;
  let errors = []
  let cardInput = Object.keys(cardInfo).map((val) => val)
  cardInput.forEach((input) => {
    let valid
    switch (input) {
      case "cardNumber":
        valid = cardValid.number(cardNumber.value)
        break;
      case "expDate":
        valid = cardValid.expirationDate(expDate.value)
        break;
      case "cvc":
        valid = cardValid.cvv(cvc.value)
        break;
      case "cardHolderName":
        let regex = /^[a-zA-Z]+(\s[a-zA-Z]+){1,}$/g
        valid = { isValid: regex.test(cardHolderName.value) }
        break;
      case "zipCode":
        valid = cardValid.postalCode(zipCode.value, { minLength: 5 })
        break;
      default:
       valid = { isValid : true };
        break;
    }
    if (!valid.isValid) {
      errors.push(input)
    }
  });
  
  return errors
}



// WEBPACK FOOTER //
// ./src/utilities/validation.js